module.exports = __webpack_public_path__ + "static/media/logo--white.2c5b7cd1.png";